/**
 * Misc — 사용자PC(/u/orders) 오더목록 페이지의 잡다 유틸(구 u-order-list.js 잔류분).
 *
 * 레거시와의 관계
 * ───────────────
 * u-order-list.js 의 마지막 잔류 함수 10개를 이 모듈로 이관하면서 u-order-list.js 를 폐기했다.
 *   - fnExcelReport      : 화면 테이블 → 엑셀(.xls) 다운로드
 *   - detailExpanseClose : 오더 상세팝업 닫기
 *   - bgcolorCh/Tdmouseover/Tdmouseout : 셀 배경색 hover
 *   - initPP             : 스크롤 위치 추적 초기화(window.doc_Scroll 갱신)
 *   - checkDefDate       : 날짜 input 기본값(오늘) 채움
 *   - showClickedOrder   : 오더 클릭 시 /u/main 팝업 열기
 *   - order_clearSet     : 오더 완료처리 → 상세팝업 재오픈
 *   - zipserchWinJob     : 빈 스텁(호출처는 있으나 no-op)
 *
 * 구조: 모듈 스코프 자유함수 + 얇은 브리지 클래스. 10개 전부 window 브리지
 *   (블레이드/bizform.php onclick · __ordersPageBoot(initPP) · 이미 이관된 모듈이 bare 로 호출).
 *
 * 외부 전역 bare 해소:
 *   - get_orders(ListRender) · show_Pop_BizForm(PopupOpener) · calanderWinPop(DateToolbar) : window 브리지
 *   - txtArea1(IE 전용 named element) : 전역
 * strict 대응: fnExcelReport 의 미선언 tab/sa → var. initPP 의 doc_Scroll 쓰기 → window.doc_Scroll
 *   (선언은 orders.blade 의 `var doc_Scroll`; ListRender 가 bare 로 읽음).
 */
import Util from '../../../Common/Util';


function zipserchWinJob(){}

/**
 * 액셀 다운로드
 * @returns {WindowProxy}
 */
function fnExcelReport(){
    var tab_text="<table border='2px'>";//<tr bgcolor='#87AFC6'>
    var textRange;
    var j=0;
    let i=0;
    var tab, sa;
    tab = document.getElementById('topTablein'); // id of table
    for(j = 0 ; j < tab.rows.length ; j++) {
        if( tab.rows[j].style.display == "none") continue;

        var eeego = "";
        for(i = 1; i <  tab.rows[j].cells.length; i++){
            eeego+="<td>" + tab.rows[j].cells[i].innerHTML + "</td>";
        }

        var ea_line = eeego;//tab.rows[j].innerHTML;
        if( !ea_line ) continue;

        if(tab.rows[j].id.indexOf("rHeader")!=-1 ) {
            tab_text=tab_text+"<tr bgcolor='#87AFC6'>" + ea_line+"</tr>";
        }else{
            tab_text=tab_text+"<tr>" + ea_line+"</tr>";
        }
    }
    tab_text=tab_text+"</table>";
    tab_text= tab_text.replace(/<A[^>]*>|<\/A>/g, "");//remove if u want links in your table
    tab_text= tab_text.replace(/<img[^>]*>/gi,""); // remove if u want images in your table
    tab_text= tab_text.replace(/<input[^>]*>|<\/input>/gi, ""); // reomves input params

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {     // If Internet Explorer
        txtArea1.document.open("txt/html","replace");
        txtArea1.document.write(tab_text);
        txtArea1.document.close();
        txtArea1.focus();
        sa=txtArea1.document.execCommand("SaveAs",true,"접수리스트.xls");
    }else{                 //other browser not tested on IE 11
        sa = window.open('data:application/vnd.ms-excel,' + encodeURIComponent(tab_text));
        return (sa);
    }
}

function bgcolorCh( tar, cc){
    tar.style.backgroundColor = cc;
}

function Tdmouseover(tar){
    tar.style.backgroundColor="#FFE7DB";
}
function Tdmouseout(tar){
    tar.style.backgroundColor="#FFFFFF";
}

/**
 * 오더 팝업창 닫기
 * @param evt
 */
function detailExpanseClose(evt){
    if( evt) {
        if (evt.preventDefault) evt.preventDefault();
        if (evt.stopPropagation) evt.stopPropagation();
    }
    $(".checkBodTd").css('background-color', '#FFFFFF');
    $('#Contract_DocTop').hide();
    $('#contractListSelATop').hide();
    var crd = document.getElementById("crd");
    if (crd) crd.style.display = "none";
    var obj = document.getElementById("detailLists");
    var obj2 = document.getElementById("detailInside");
    if (obj) obj.style.display = "none";
    if (obj2) obj2.innerHTML = "";

    get_orders();
}

function initPP(){
    // setTimeout(keepSessioin, 1000*60*3);
    var iframe = document.getElementById('DBSDsTop');
    document.body.onscroll = function (e) {

    }
    document.body.addEventListener('scroll',function(event){
        var Top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
        window.doc_Scroll = Top;
    });
}

function checkDefDate(tar){
    var obj = document.getElementById(tar);
    if( obj.value.length < 10 ){
        var dt = new Date();
        var n = dt.getFullYear() + "-" + Util.number_to_withzero((dt.getMonth() + 1),2) + "-" + Util.number_to_withzero(dt.getDate(),2);
        obj.value=n;
    }
}

function showClickedOrder(n, onum,wday){
    // console.log( onum);
    var popUp = window.open("","mainbuller","top=9000");
    try{
        // if(popUp.document.body.innerHTML){
        // 	console.log(popUp);
        // 	console.log(popUp.location.href);
        let url = "/u/main?showmode=order&showorder=" + onum + "&workday=" + wday;
        popUp.location.href = url;
        // } else{
        // 	popUp.close();
        // 	calanderWinPop( 22 );
        // }
    } catch(e){alert("Exist, but not my domain");}
}

function order_clearSet(ordernum,evt,ssmode,zzz,callmode){
    evt.stopImmediatePropagation();
    if(! confirm("이 오더를 완료처리할까요?")) return;
    var adr="/u/ajax/order-tax/all-done";
    var sendData = {"orderNum":ordernum};

    $.ajax({type:"POST", url:adr, data:sendData, success:function(data){
            console.log( data );
            show_Pop_BizForm(ordernum,callmode);
        }});

}

export default class Misc {
    zipserchWinJob = zipserchWinJob;
    fnExcelReport = fnExcelReport;
    bgcolorCh = bgcolorCh;
    Tdmouseover = Tdmouseover;
    Tdmouseout = Tdmouseout;
    detailExpanseClose = detailExpanseClose;
    initPP = initPP;
    checkDefDate = checkDefDate;
    showClickedOrder = showClickedOrder;
    order_clearSet = order_clearSet;
}
